import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CardIcon } from 'src/app/utils/interfaces/old/card-icon-interface';

@Component({
  selector: 'frg-card-no-scroll',
  templateUrl: './card-no-scroll.fragment.html',
  styleUrls: ['./card-no-scroll.fragment.scss']
})
export class CardNoScrollFragment implements OnInit, AfterViewInit {

  @ViewChild('emptyIconRef') public emptyIconElem: ElementRef;
  @ViewChild('fullIconRef') public fullIconElem: ElementRef;
  @ViewChild('subtitleColorRef') public subtitleColorRef: ElementRef;

  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public subtitleColor: string;
  @Input() public emptyIcon?: CardIcon;
  @Input() public fullIcon?: CardIcon;
  @Input() public border = true;


  @Output()
  public activated = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    if (this.emptyIcon && this.emptyIcon.color && this.emptyIconElem) {
      this.emptyIconElem.nativeElement.style.border = 'solid 1px ' + this.emptyIcon.color;
    }
    if (this.fullIcon && this.fullIcon.color && this.fullIconElem) {
      this.fullIconElem.nativeElement.style.background = this.fullIcon.color;
      this.setBoxShadow();
    }
    if (this.subtitleColor) {
      this.subtitleColorRef.nativeElement.style.color = this.subtitleColor;
    }
  }

  // Ajoute un boxShadow de la couleur passé en paramètre.
  // La couleur peut-être de l'hexadécimal ou une variable.
  public setBoxShadow(): void {
    let colorToRGB;
    // Si elle contient un # et fais 7 ou 4 de long c'est de l'hexadécimal (#fff ou #ffffff)
    if (this.fullIcon.color.includes('#') && this.fullIcon.color.trim().length === 7 || this.fullIcon.color.trim().length === 4) {
      colorToRGB = this.hexToRgb(this.fullIcon.color);
    } else {
      // Si c'est une variable, il faut aller chercher sa valeur hexadécimal.
      // Pour ce faire il faut lui envoyer seulement le nom de la variable, on la découpe donc (slice)
      const styleToHex = getComputedStyle(document.documentElement)
        .getPropertyValue(this.fullIcon.color.slice(4, this.fullIcon.color.length - 1));
      colorToRGB = this.hexToRgb(styleToHex.trim());
    }
    this.fullIconElem.nativeElement.style.boxShadow = `0px 8px 16px rgba(${colorToRGB.r}, ${colorToRGB.g}, ${colorToRGB.b}, 0.14), 0px 4px 8px rgba(${colorToRGB.r}, ${colorToRGB.g}, ${colorToRGB.b}, 0.14)`;
  }

  // Transforme l'hexadécimal en rgb
  private hexToRgb(hex: string): any {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  public active(): void {
    this.activated.emit();
  }

}
